import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PButtonComponent } from './atoms/p-button/p-button.component';
import { PInputComponent } from './atoms/p-input/p-input.component';
import { PLoaderComponent } from './atoms/p-loader/p-loader.component';
import { PRadioComponent } from './atoms/p-radio/p-radio.component';
import { PSelectComponent } from './atoms/p-select/p-select.component';
import { PSeparatorComponent } from './atoms/p-separator/p-separator.component';
import { PTextareaComponent } from './atoms/p-textarea/p-textarea.component';
import { PToggleComponent } from './atoms/p-toggle/p-toggle.component';
import { IconsModule } from './icons/icons.module';
import { PBrandComponent } from './molecules/p-brand/p-brand.component';
import { PPercentageLabelComponent } from './molecules/p-percentage-label/p-percentage-label.component';
import { PToastInpageComponent } from './molecules/p-toast-inpage/p-toast-inpage.component';
import { PYearPickerComponent } from './molecules/p-yearpicker/p-yearpicker.component';
import { PFooterComponent } from './organisms/p-footer/p-footer.component';
import { PFormWrapperComponent } from './organisms/p-form-wrapper/p-form-wrapper.component';
import { PHeaderComponent } from './organisms/p-header/p-header.component';
import { PModalComponent } from './organisms/p-modal/p-modal.component';
import { PPaginationComponent } from './organisms/p-pagination/p-pagination.component';
import { PPhotoEditorComponent } from './organisms/p-photo-editor/p-photo-editor.component';
import { PPhotoMinatureComponent } from './organisms/p-photo-miniature/p-photo-miniature.component';
import { PTableComponent } from './organisms/p-table/p-table.component';
import { PWrapperComponent } from './organisms/p-wrapper/p-wrapper.component';
import { PAutocompleteComponent } from './atoms/p-autocomplete/p-autocomplete.component';
import { PVerticalSeparatorComponent } from './atoms/p-vertical-separator/p-vertical-separator.component';
import { PExpandableTextComponent } from './molecules/p-expandable-text/p-expandable-text.component';
import { PAccountMenuComponent } from './organisms/p-account-menu/p-account-menu.component';
import { PMainMenuComponent } from './organisms/p-main-menu/p-main-menu.component';
import { FadeInScrollDirective } from '../directives/fade-in-scroll.directive';
import { HasAccessDirective } from '../directives/has-access.directive';
import { MaxLengthNumberDirective } from '../directives/max-length-number.directive';
import { PStepperComponent } from './organisms/p-stepper/p-stepper.component';
import { PErrorNotificationComponent } from './molecules/p-error-notification/p-error-notification.component';

@NgModule({
  declarations: [
    PBrandComponent,
    PHeaderComponent,
    PWrapperComponent,
    PSeparatorComponent,
    PFooterComponent,
    PFormWrapperComponent,
    PModalComponent,
    PToastInpageComponent,
    PTableComponent,
    PPaginationComponent,
    PRadioComponent,
    PPercentageLabelComponent,
    PPhotoEditorComponent,
    PYearPickerComponent,
    PPhotoMinatureComponent,
    PToggleComponent,
    PAutocompleteComponent,
    FadeInScrollDirective,
    PVerticalSeparatorComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    IconsModule,
    RouterModule,
    HasAccessDirective,
    PAccountMenuComponent,
    PMainMenuComponent,
    PStepperComponent,
    PButtonComponent,
    PInputComponent,
    MaxLengthNumberDirective,
    PSelectComponent,
    PLoaderComponent,
    PErrorNotificationComponent,
    PExpandableTextComponent,
    PTextareaComponent,
  ],
  providers: [],
  bootstrap: [],
  exports: [
    PButtonComponent,
    PInputComponent,
    PBrandComponent,
    PHeaderComponent,
    PWrapperComponent,
    PSeparatorComponent,
    PFooterComponent,
    IconsModule,
    PFormWrapperComponent,
    PModalComponent,
    PLoaderComponent,
    PToastInpageComponent,
    PTableComponent,
    PSelectComponent,
    PPaginationComponent,
    PRadioComponent,
    PPercentageLabelComponent,
    PTextareaComponent,
    PPhotoEditorComponent,
    PYearPickerComponent,
    PPhotoMinatureComponent,
    PToggleComponent,
    PAutocompleteComponent,
    FadeInScrollDirective,
    PVerticalSeparatorComponent,
    PExpandableTextComponent,
    PStepperComponent,
    MaxLengthNumberDirective,
    PErrorNotificationComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DesignSystemModule {}
